import classNames from 'classnames';
import { CancellationReasonChoice } from 'src/types';
import styles from './CancelSubscriptionReasonItem.module.scss';
import { TextareaSimple } from 'src/v2/commonComponents/TextareaSimple';

interface CancelSubscriptionReasonItemProps {
  value: CancellationReasonChoice;
  selectedValue: string | undefined;
  placeholder: string;
  label: string;
  reasonDescription: string;
  onReasonChange: (value: CancellationReasonChoice) => void;
  onChangeReasonDescription: (value: string) => void;
}

const MIN_INPUT_ROWS = 1;
const MAX_INPUT_ROWS = 4;

export const CancelSubscriptionReasonItem = ({
  value,
  selectedValue,
  placeholder,
  label,
  reasonDescription,
  onReasonChange,
  onChangeReasonDescription,
}: CancelSubscriptionReasonItemProps) => {
  return (
    <div key={value} className={styles.root}>
      <label
        className={classNames(styles.radioOption, {
          [styles.selected]: selectedValue === value,
        })}
      >
        <input
          type="radio"
          name="cancel_reason"
          value={value}
          checked={selectedValue === value}
          onChange={() => onReasonChange(value)}
        />
        <span className={styles.radioCircleBackground}>
          <span className={styles.radioCircle}></span>
        </span>
        <span className={styles.radioLabel}>{label}</span>
      </label>

      {selectedValue === value && (
        <TextareaSimple
          minRows={MIN_INPUT_ROWS}
          maxRows={MAX_INPUT_ROWS}
          value={reasonDescription}
          placeholder={placeholder}
          onChange={onChangeReasonDescription}
          className={styles.textarea}
        />
      )}
    </div>
  );
};
